import React from 'react';

/**
 * JournalSortSelect
 * - Controlled select for journal sorting.
 * - Props:
 *   - sort: { order_by: string, order: 'asc'|'desc' }
 *   - onChange: (nextSort) => void
 *   - className: optional additional class names
 */
export default function JournalSortSelect({sort = {order_by: 'ranking', order: 'asc'}, onChange, className = ''}) {
    const value = `${sort?.order_by ?? 'ranking'}:${sort?.order ?? 'asc'}`;

    const handleChange = (e) => {
        const [ob, od] = String(e.target.value).split(':');
        const nextSort = {order_by: ob || 'ranking', order: od || 'asc'};
        if (typeof onChange === 'function') onChange(nextSort);
    };

    return (
        <div className="sort min-[800px]:flex items-center gap-3 text-[13px] text-[#6C7687] font-medium">
            <p className="hidden min-[800px]:flex items-center gap-1">
                <img src={`${rmVars.themeUrl}images/filter_list_ico.png`} className="w-4 h-4"
                    alt="sort icon"/>
                Sort by
            </p>
            <select
                className={`w-full py-2 px-3 bg-white border border-[#E4E8F1] rounded-lg appearance-none bg-[url('/images/expand_more_8D9AAF.png')] bg-no-repeat bg-size-[18px] bg-position-[98%] text-[13px] text-[#6C7687] outline-none min-[800px]:w-[184px] ${className}`}
                value={value}
                onChange={handleChange}
            >
                <option className="bg-white" value="score:desc">Relevance</option>
                <option className="bg-white" value="ranking:asc">Ranking : highest first</option>
                <option className="bg-white" value="ranking:desc">Ranking : lowest first</option>
                <option className="bg-white" value="title:asc">Journal Title : A to Z</option>
                <option className="bg-white" value="title:desc">Journal Title : Z to A</option>
            </select>
        </div>
    );
}
